<template>
	<div style="height: 100%; overflow: hidden; position: relative;">
		<v-tabs-items
				:value="cActiveTab"
				style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; z-index: 1;"
		>
			<v-tab-item
					value="list"
					style="height: 100%; overflow-y: auto;"
			>
				<v-container
						fluid
				>
					<gh-shop-list v-if="cShops && cShops.length > 0"
							:items="cShops"
							#default="{ item }"
					>
						<gh-shop-list-item
								:item="item"
								:to="{ name: 'shop', params: { id: item.id } }"
						/>
					</gh-shop-list>
					<div
							v-else
							class="pa-5 text-center headline"
					>Keine Einträge gefunden</div>
				</v-container>
			</v-tab-item>

			<v-tab-item
					value="map"
					style="position: relative; height: 100%;"
			>
				<RTMap
						:items="cShops"
						style="position: absolute; left: 0; right: 0; top: 0; bottom: 0;"
						height="100%"
				/>
			</v-tab-item>
		</v-tabs-items>
		<v-btn
				absolute
				fab
				large
				@click.stop="onClickToggleTab"
				color="primary"
				style="z-index: 2; right: 0.75em; top: 0.75em;"
		>
			<v-icon>{{ cToggleBtnIcon }}</v-icon>
		</v-btn>
		<router-view />
	</div>
</template>

<script>
import shops from '@/assets/shops'
import RTMap from '@/components/map/RTMap'
import {categoryBase} from '@/mixins/categoryBase.js'
import {shopBase} from '@/mixins/shopBase.js'
import {helper} from '@/mixins/helper.js'

import {
	GhShopList,
	GhShopListItem
} from '@/components/shop-list'
// import RTdonate from '@/components/RTdonate.vue'

export default {
	name: 'ListView',
	mixins:[
		helper,
		categoryBase,
		shopBase
	],
	components: {
		GhShopListItem,
		GhShopList,
		RTMap
	},
	data () {
		return {
			showNavbar:false,
			minBarVisiblePosition:0,
			shops
		}
	},
	watch:{
	},
	computed:{
		cNumShops () {
			return this.shops.length
		},
        cSubtitle(){
            return `Kauf direkt und ohne Umwege von ${this.cNumShops} lokalen Unternehmen`;
        },
		cActiveTab () {
			return this.$store.getters['app/shopListTab']
		},
		cToggleBtnIcon () {
			switch (this.cActiveTab) {
				case 'list':
					return 'mdi-map'
				case 'map':
				default:
					return 'mdi-format-list-text'
			}
		},
		cFilter () {
			return this.$store.getters['app/shopListFilter']
		},
		cShops () {
			const category = this.cFilter.category
			const shipping = this.cFilter.shipping
			const text = this.cFilter.text.toLowerCase().trim()

			const filterEmpty = category.length === 0 &&
					shipping === null &&
					text.length === 0

			const filterFun = (el) => {
				let result = true

				if (!filterEmpty) {
					// when shipping-filter is set
					if (shipping !== null) {
						// require shop to include selected shipping
						result = result &&
								el.ship.indexOf(shipping) > -1
					}

					// when category-filter is set
					if (category.length > 0) {
						// require shop to belong to at least one category
						result = result &&
								el.category.reduce((acc, el) => acc || category.indexOf(el) > -1, false)
					}

					// when text-filter is set
					if (text.length > 0) {
						// require the search string to be present in title, description OR company
						result = result && (
								el.title.toLowerCase().includes(text) ||
								el.company.toLowerCase().includes(text) ||
								el.descr.toLowerCase().includes(text)
						)
					}
				}

				return result
			}

			return this.shops.filter(filterFun)
		}
	},
	methods:{
		onClickResetFilter () {
			this.resetFilter()
		},
		resetFilter () {
			this.filter.text = ''
			this.shipping = null
			this.$set(this.filter, 'category', [])
		},
		onScroll () {
			const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
			this.showNavbar = currentScrollPosition > this.minBarVisiblePosition
		},
		setNavbarPosition(){
			/*
			let div = document.getElementById('filterNavBar');
			let divOffset = this.offset(div);
			this.minBarVisiblePosition=divOffset.top;
			*/
		},
		initScrollBehaviour(){
			this.$nextTick(()=>{
				window.addEventListener('onorientationchange', this.setNavbarPosition);
				window.addEventListener('scroll', this.onScroll);
				this.setNavbarPosition();
			});
		},
		onClickToggleTab () {
			this.toggleTab()
		},
		toggleTab () {
			this.$store.commit('app/toggleShopListTab')
		}
	},

	activated() {
		//window.scrollTo(0, this.scrollposition);
	},
	beforeRouteLeave(to, from, next) {
		next()
	},

	beforeRouteEnter: (to,from,next) => {
		next(() => {
		});
	},


	mounted () {
		this.initScrollBehaviour();
	},
	beforeDestroy () {
		window.removeEventListener('scroll', this.onScroll)
	}
}
</script>

<style scoped lang="scss">
	.rt_logo{
		color:black;
		fill: black;
	}

	.v-card{
		border-radius:5px;
		-webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
		box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
	}
	.v-card:hover {
		-webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
		box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
	}

	::v-deep .v-tabs-items > .v-window__container {
		height: 100%;
	}

</style>
